<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="container" :class="themeClass">
      <sc-rich-text class="rich-text" tag="div" :field="text"/>
      <editorial-cta :fields="fields" />
    </div>
  </sc-render>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue'
import mapFields from '~/helpers/map-fields'
import ScRender from '../sc-render/'
import EditorialCta from '../editorial-cta'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'EditorialRichText',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRender,
    ScRichText,
    EditorialCta
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    ...mapFields({ text: 'text' }),
    themeClass () {
      return this.isDarkTheme ? 'theme-black' : ' '
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 $space-050;
  margin-bottom: $space-090;

  @include tablet {
    & {
      padding: 0 25%;
      margin-bottom: $space-100;
    }
  }

  .rich-text ::v-deep {
    p {
      @include font('070');
      @include stack-space($space-070);
    }
    h1, h2, h3, h4, h5 {
      font-weight: $f-weight-regular;
    }
  }
}

.theme-black {
  .container {
    @include outline-focus ($color-white);
  }

  .rich-text ::v-deep {
    color: $color-white;

    p, div, a {
      color: $color-white;
    }
  }
}
</style>
